import React from 'react';
import { Headphones, Phone, MessageSquare, Clock } from 'lucide-react';

export default function MesaSpinDashboard() {
  const cardClasses = 'bg-white/10 backdrop-blur-md border border-white/20';
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-red-900 to-orange-900 text-white p-6">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <h1 className="text-4xl font-bold bg-gradient-to-r from-red-400 to-orange-400 bg-clip-text text-transparent">
            Mesa de Ayuda Spin
          </h1>
          <p className="text-lg opacity-80 mt-2">Centro de Atención y Soporte Técnico</p>
        </div>
        
        <div className={`${cardClasses} p-8 rounded-2xl text-center`}>
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-r from-red-500 to-orange-500 rounded-full mb-6">
            <Headphones className="w-10 h-10 text-white" />
          </div>
          
          <h2 className="text-2xl font-bold mb-4">Área en Construcción</h2>
          <p className="text-gray-300 mb-6">
            El dashboard de Mesa Spin estará disponible próximamente con métricas de:
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 max-w-3xl mx-auto">
            <div className={`${cardClasses} p-4 rounded-lg`}>
              <Phone className="w-8 h-8 mx-auto mb-2 text-red-400" />
              <p className="font-semibold">Llamadas Atendidas</p>
            </div>
            <div className={`${cardClasses} p-4 rounded-lg`}>
              <MessageSquare className="w-8 h-8 mx-auto mb-2 text-orange-400" />
              <p className="font-semibold">Tickets de Soporte</p>
            </div>
            <div className={`${cardClasses} p-4 rounded-lg`}>
              <Clock className="w-8 h-8 mx-auto mb-2 text-red-300" />
              <p className="font-semibold">Tiempo de Respuesta</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}